<template>
  <div v-if="openDialog" class="dialog-overlay">
    <v-card class="dialog-content">
      <slot>
        <v-btn icon="mdi-close" variant="text" density="compact" color="primary" class="close-icon"
          @click="fecharDialog"></v-btn>
        <img v-if="dialogContent.image" :src="dialogContent.image" alt="Imagem da modal">
        <v-card-title v-if="dialogContent.title">
          {{ dialogContent.title }}
        </v-card-title>
        <v-card-text v-if="dialogContent.text">
          {{ dialogContent.text }}
        </v-card-text>
        <v-card-actions class="py-0">
          <v-btn class="close-button" @click="fecharDialog">OK</v-btn>
        </v-card-actions>
      </slot>
    </v-card>
  </div>
</template>

<script setup lang="ts">
import { VCard, VCardTitle, VCardText, VCardActions, VBtn } from 'vuetify/components';

defineProps<{
  openDialog: boolean,
  dialogContent: DialogContent,
}>()

const emit = defineEmits(["fechar-dialog"]);

const fecharDialog = () => emit("fechar-dialog");

</script>

<style scoped lang="scss">
@use "@/styles/variables" as *;

.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.dialog-content {
  width: 259px;
  height: 297px;
  background: $white;
  padding: 32px 23px 42px;
  border-radius: 20px;
  box-shadow: 0 0 10px $shadowColor;
  text-align: center;

  .close-icon {
    text-transform: none;
    position: absolute;
    left: 83%;
    top: 6%;
  }

  .v-card-title,
  .v-card-text {
    color: $greyDark;
    font-size: 16px;
    line-height: 150%;
    white-space: unset;
  }

  .v-card-title {
    font-weight: 800;
    padding: 0px !important;
  }

  .v-card-text {
    font-weight: 400;
    padding: 0px;
  }

  .close-button {
    display: flex;
    width: 118px;
    height: 45px;
    margin: 16px auto 0px;
    padding: 12px 0px 11px 0px;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    background: #3303FF;
    color: white !important;
    font-size: 16px;
    font-weight: 800;
    width: 118px;
  }
}
</style>
